import * as s from "./website-black-workflow.scss";
import {Component} from "../../../../../../sedestral/framework/interface/component/Component";
import {NetworkVendor} from "../../../../../../network/NetworkVendor";
import {Resources} from "../../../../../../resources/Resources";
import {Network} from "../../../../../../network/Network";

export class WebsiteBlackWorkflowComponent extends Component {

    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackWorkflow}">
                <h2 class="${s.bigTitle}">
                    ${Resources.t("words.perfectSeoSolution")}
                </h2>
                <div class="${s.columns}">
                    <div class="${s.column}">
                        <div class="${s.left}">
                            <h3 class="${s.title}">
                                ${Resources.t("words.explore")}
                            </h3>
                            <div class="${s.content}">
                                <div class="${s.icon} ${s.topics}"></div>
                                <p class="${s.description}">
                                    ${Resources.t("words.useTopicsToGuideContent")}
                                </p>
                            </div>
                            <div class="${s.content}">
                                <div class="${s.icon} ${s.fire}"></div>
                                <p class="${s.description}">
                                    ${Resources.t("words.identifySeoOpportunities")}
                                </p>
                            </div>
                            <a href="${Network.router.pages.getUrlWithPath('topics')}" class="${s.button}">
                                ${Resources.t("words.topics")}
                                <div class="${s.icon}"></div>
                            </a>
                        </div>
                        <div class="${s.right}">
                            <img class="${s.img} ${s.topicalMap}" src="${NetworkVendor.image("blog-aa.svg")}"
                                 alt="${Resources.t("words.seoTopicMap")}"/>
                        </div>
                    </div>
                    <div class="${s.column}">
                        <div class="${s.left}">
                            <h3 class="${s.title}">
                                ${Resources.t("words.workCreateAndOptimize")}
                            </h3>
                            <div class="${s.content}">
                                <div class="${s.icon} ${s.aiWriting}"></div>
                                <p class="${s.description}">
                                    ${Resources.t("words.workManualContentWithSeoTools")}
                                </p>
                            </div>
                            <div class="${s.content}">
                                <div class="${s.icon} ${s.aiWrite}"></div>
                                <p class="${s.description}">
                                    ${Resources.t("words.workAiGeneratedSeoContent")}
                                </p>
                            </div>
                            <a href="${Network.router.pages.getUrlWithPath('editor')}" class="${s.button}">
                                ${Resources.t("words.workContentEditor")}
                                <div class="${s.icon}"></div>
                            </a>
                        </div>
                        <div class="${s.right}">
                            <img class="${s.img}" src="${NetworkVendor.image("blog-ab.svg")}"
                                 alt="${Resources.t("words.workOptimizePageSeo")}"/>
                        </div>
                    </div>
                    <div class="${s.column}">
                        <div class="${s.left}">
                            <h3 class="${s.title}">
                                ${Resources.t("words.workMonitorAndAnalyze")}
                            </h3>
                            <div class="${s.content}">
                                <div class="${s.icon} ${s.chart}"></div>
                                <p class="${s.description}">
                                    ${Resources.t("words.workTrackAndOptimizeContent")}
                                </p>
                            </div>
                            <div class="${s.content}">
                                <div class="${s.icon} ${s.fireBlack}"></div>
                                <p class="${s.description}">
                                    ${Resources.t("words.workSiteAuditAndTracking")}
                                </p>
                            </div>
                            <a href="${Network.router.pages.getUrlWithPath('analysis')}" class="${s.button}">
                                ${Resources.t("words.workSeoAnalysis")}
                                <div class="${s.icon}"></div>
                            </a>
                        </div>
                        <div class="${s.right}">
                            <img class="${s.img} ${s.chart}" src="${NetworkVendor.image("blog-ac.svg")}"
                                 alt="${Resources.t("words.workSeoAnalysis")}"/>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    commit() {
        this.els(s.column).forEach(entryContainer => {
            this.putListener(window, "scroll", () => {
                let top = entryContainer.getOffsets().top - window.innerHeight + ((window.innerHeight / 2));
                if (top <= 0) {
                    let scale = 1 + (Math.min(Math.abs(top), 250) / 250);
                    let chart = entryContainer.el(s.topicalMap);
                    if (!chart.isNull()) {
                        chart.setStyle(`transform: scale(${scale});`);
                    }
                } else {
                    let chart = entryContainer.el(s.topicalMap);
                    if (!chart.isNull()) {
                        chart.setStyle(`transform: scale(1);`);
                    }
                }
            });
        });


        super.commit();
    }
}